import PaymentBadges from "./PaymentBadges";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-cream-soft text-ink px-6 md:px-12 py-16 border-t border-line"
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <h3 className="font-display text-2xl md:text-3xl mb-3">
            Anabela <span className="text-orange">Reis</span>
          </h3>
          <p className="smallcaps mb-5">Coach · Formadora · Autora</p>
          <p className="text-ink-soft leading-relaxed max-w-md">
            Acompanho pessoas em momentos de viragem. Escrevo para quem está
            pronta para ouvir o que já sabe.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="smallcaps mb-4">Navegar</p>
          <ul className="space-y-2">
            {[["O livro", "#sobre"], ["Capítulos", "#capitulos"], ["Autora", "#autora"], ["Dúvidas frequentes", "#faq"]].map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  data-testid={`footer-link-${href.replace("#", "")}`}
                  className="text-ink hover:text-orange transition-colors duration-200 text-sm"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="smallcaps mb-4">Contacto</p>
          <a
            href="mailto:info@anabelareisconsultoria.pt"
            data-testid="footer-email"
            className="block text-base text-ink hover:text-orange transition-colors duration-200 mb-5 break-all"
          >
            info@anabelareisconsultoria.pt
          </a>
          <p className="text-sm text-ink-soft leading-relaxed">
            Checkout seguro via Stripe.
            <br />
            Recebe o PDF no teu e-mail logo após o pagamento.
          </p>
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto mt-12 pt-8 border-t border-line">
        <p className="smallcaps mb-4 text-center md:text-left">
          Métodos de pagamento aceites
        </p>
        <PaymentBadges />
      </div>

      <div className="max-w-[1200px] mx-auto mt-10 pt-6 border-t border-line text-center md:text-left">
        <p className="text-xs text-ink-soft">
          © {new Date().getFullYear()} Anabela Reis · Todos os direitos reservados
        </p>
      </div>
    </footer>
  );
}
